import React from 'react';
import styled from 'styled-components';
import zxcvbn from 'zxcvbn';
import { scorePenalty } from '../../util/validation';

interface Props {
  password: string;
}

interface StyledProps {
  width?: string;
  backgroundColor?: string;
  color?: string;
}

const ProgressBar = styled.div<StyledProps>`
  width: ${props => props.width};
  max-width: 100%;
  height: 3px;
  margin: 7px 0px 0px 0px;
  background-color: ${props =>
    props.backgroundColor ? props.backgroundColor : '#EA1111'};
`;

const ProgressMessage = styled.p<StyledProps>`
  margin: 0;
  color: ${props => (props.color ? props.color : '')};
`;

const PasswordStrengthBar = ({ password }: Props) => {
  const testResult = zxcvbn(password);
  const penalty = scorePenalty(password);
  const score = testResult.score - penalty;
  const num = (score * 100) / 4;

  const createPassLabel = () => {
    switch (true) {
      case !testResult.score:
        return 'Força da senha: Fraca';
      case score <= 1:
        return 'Força da senha: Fraca';
      case score === 2:
        return 'Força da senha: Média';
      case score === 3:
        return 'Força da senha: Forte';
      case score === 4:
        return 'Força da senha: Muito Forte';
      default:
        return '';
    }
  };

  const funcProgressColor = () => {
    switch (true) {
      case !testResult.score:
        return '#EA1111';
      case score <= 1:
        return '#EA1111';
      case score === 2:
        return '#FFAD00';
      case score >= 3:
        return '#00b500';
      default:
        return '';
    }
  };

  return (
    <>
      <div className="progress">
        <ProgressBar
          width={num && num > 0 ? `${num}%` : '25%'}
          backgroundColor={funcProgressColor()}
        />
      </div>
      <ProgressMessage color={funcProgressColor()}>
        {createPassLabel()}
      </ProgressMessage>
    </>
  );
};

export default PasswordStrengthBar;
